import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { fetchPlanningConfiguration } from "../../../../redux/slicers/instanceSlice";

export const usePlanningConfiguration = () => {
  const dispatch = useDispatch<AppDispatch>();

  const config = useSelector((state: RootState) => state.instance.planningConfiguration);
  const loading = useSelector((state: RootState) => state.instance.loading);
  const error = useSelector((state: RootState) => state.instance.error);

  useEffect(() => {
    if (!config) {
      dispatch(fetchPlanningConfiguration());
    }
  }, [config, dispatch]);

  return {
    config: config || { days: [], timeSlots: [] },
    loading,
    error,
  };
};
